import React from 'react';
import PropTypes from 'prop-types';
import { FixedTooltip, themes, Tooltip, TooltipContent } from '../Tooltip';

const actionTypes = Object.freeze({
    edit: { content: 'EDIT', theme: 'action' },
    remove: { content: 'REMOVE', theme: 'danger' },
    alert: { content: 'This is an alert.', theme: 'alert' },
});
export const actionTypeNames = Object.keys(actionTypes);

const positions = [
    'top',
    'top-left',
    'top-right',
    'bottom',
    'bottom-left',
    'bottom-right',
    'left',
    'left-top',
    'left-bottom',
    'right',
    'right-top',
    'right-bottom',
];

export const ActionTooltip = ({
    actionType = 'edit',
    children,
    className,
    customContent,
    hasBorder,
    hasSetWidth,
    isEnabled,
    isFixed,
    gapSize,
    position = 'top-right',
    shouldUseDisabledOverlay,
    theme,
}) => {
    if (!isEnabled) {
        return children;
    }

    const actionData = actionTypes[actionType] || actionTypes['edit'];
    const { content } = actionData;

    return isFixed ? (
        <FixedTooltip
            className={className}
            content={() => customContent || content}
            position={position}
            theme={theme || actionData.theme}
            hasBorder={hasBorder}
            hasSetWidth={hasSetWidth}
            gapSize={gapSize}
            shouldUseDisabledOverlay={shouldUseDisabledOverlay}
        >
            {children}
        </FixedTooltip>
    ) : (
        <Tooltip className={className} position={position}>
            <TooltipContent
                theme={theme || actionData.theme}
                hasBorder={hasBorder}
                hasSetWidth={hasSetWidth}
            >
                {customContent || content}
            </TooltipContent>
            {children}
        </Tooltip>
    );
};

ActionTooltip.propTypes = {
    actionType: PropTypes.oneOf(actionTypeNames),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    customContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    hasBorder: PropTypes.bool,
    hasSetWidth: PropTypes.bool,
    isEnabled: PropTypes.bool,
    isFixed: PropTypes.bool,
    position: PropTypes.oneOf(positions),
    shouldUseDisabledOverlay: PropTypes.bool,
    theme: PropTypes.oneOf(themes),
};
